module.exports = __webpack_public_path__ + "img/footer.2864c728.png";